import { Text } from "@mantine/core";

export const ReadReceiptContent: React.FC = () => {
  return <Text size="sm">Read receipt received</Text>;
};
